import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export default () => {
    document.addEventListener("DOMContentLoaded", function () {
        const blockIconsSlider = document.querySelectorAll(
            ".blockIcons__slider"
        );

        if (blockIconsSlider) {
            blockIconsSlider.forEach((singleSlider) => {
                const splideIcons = new window.splide(singleSlider, {
                    pagination: false,
                    arrows: false,
                    gap: "140px",
                    type: "loop",
                    drag: "free",
                    focus: "center",
                    perPage: 5,
                    autoScroll: {
                        speed: 1,
                        pauseOnHover: false,
                    },
                    breakpoints: {
                        1224: {
                            perPage: 4,
                            gap: "40px",
                        },
                        767: {
                            perPage: 2,
                        },
                    },
                });

                splideIcons.mount({ AutoScroll });
            });
        }
    });
}